import React, { useEffect, useState } from "react";

function MyMongo() {
	const [data, setData] = useState([])
    
    const fetchData = async() => {
    	// const response = await fetch('/.netlify/functions/getData')
        const response = await fetch('/getData')

        const result = await response.json()
        setData(result)
    }
    
    useEffect(() => {
    	fetchData()
    }, [])
    
    return (
        <div>
                <td>{data}</td>
        </div>

    )
}

export { MyMongo};
